<template>
  <div class="header">
    <div class="header-content">
      <a href="/" target="_self"><img src="@/assets/images/hsk_mock_logo.png" alt="" /></a>
      <div class="user-option">
        <span class="user flex">
          <img
            :src="userAvatar"
            alt=""
            class="user-avatar"
            v-if="userAvatar.includes('/person.avatar') && !userAvatar.includes('auth0')"
          />
          <img src="@/assets/images/avatar-moren.png" alt="" v-else class="user-avatar" />
          <span class="user-name">{{ userName }}</span>
        </span>
        <span class="clickable logout" @click="handleLogout">{{ $t('logout') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SimpleHeader',
  computed: {
    ...mapGetters('user', {
      displayName: 'displayName',
    }),
    userName() {
      return this.$store.state.user.nickname || ''
    },
    userAvatar() {
      return this.$store.state.user.picture || ''
    },
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('user/handleLogout', { reLogin: false })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  background-color: #2c2f46;
  display: flex;
  align-items: center;
  justify-content: center;

  &-content {
    width: 1200px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .user-option {
    display: flex;
    align-items: center;
  }

  .user {
    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 8px;
    }

    .user-name {
      line-height: 24px;
      color: #ffffff;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .logout {
    margin-left: 16px;
    padding-left: 16px;
    border-left: 1px solid #515571;
    line-height: 24px;
    color: #ffffff;
  }
}
@media (max-width: 768px) {
  .header-content {
    width: 100% !important;
    padding: 0 17px;
  }
}
</style>
